export function validateInput(value) {
    if (!value || value.trim() === "") {
        return {
            isValid: false,
            error: "This field is required."
        };
    }

    value = value.trim();

    const maliciousPatterns = [
        /<\/?.*?>/i,
        // Any HTML tag
        /<\s*\/?\s*[a-z][^>]*>/i,

        // Encoded HTML tag
        /&lt;\s*\/?\s*[a-z][^&]*&gt;/i,


        // Script tags
        /<\s*script\b/i,
        /<\/\s*script\s*>/i,
        /&lt;\s*script\b/i,
        /&lt;\s*\/\s*script\s*&gt;/i,


        // Dangerous protocols
        /javascript:/i,
        /vbscript:/i,
        /data:text\/html/i,

        // Event handlers
        /\bon\w+\s*=/i,


        // JavaScript execution

        /\beval\s*\(/i,
        /\balert\s*\(/i,
        /\bdocument\./i,
        /\bwindow\./i,

        /\bsettimeout\s*\(/i,
        /\bsetinterval\s*\(/i,
        /\bfetch\s*\(/i,
        /\bxmlhttprequest\b/i,

        // SQL Injection - only standalone SQL statements
        /^\s*select\s+(?:\*|[\w,\s]+)\s+from\s+\w+\s*(?:where\b.*)?;?\s*$/i,
        /^\s*insert\s+into\s+\w+\s*(?:\([^)]*\))?\s*values\s*\([^)]*\)\s*;?\s*$/i,
        /^\s*delete\s+from\s+\w+\s*(?:where\b.*)?;?\s*$/i,
        /^\s*drop\s+table\s+\w+\s*;?\s*$/i,
        /^\s*create\s+table\s+\w+\s*(?:\(|;|$)/i,
        /^\s*alter\s+table\s+\w+\s+(?:add|drop|modify|alter)\b.*;?\s*$/i,
        /^\s*truncate\s+table\s+\w+\s*;?\s*$/i,
        /^\s*update\s+\w+\s+set\s+\w+\s*=\s*.+?(?:where\b.*)?;?\s*$/i,

        // Advanced SQL attack patterns
        /\bxp_cmdshell\b/i,
        /\bsp_executesql\b/i,
        /\binformation_schema\b/i,
        /\bload_file\s*\(/i,
        /\binto\s+outfile\b/i,
        /\bbenchmark\s*\(/i,
        /\bsleep\s*\(/i,
        /\bwaitfor\s+delay\b/i,
        /\bunion\s+select\b/i,

        // SQL auth bypass
        /\bor\s+1\s*=\s*1\b/i,
        /\band\s+1\s*=\s*1\b/i,
        /'\s*or\s*'/i,
        /"\s*or\s*"/i,

        // SQL comments
        /\/\*/,
        /\*\//,

        // Template / Command Injection

        
        /\$\{/,
        /\$\(/,

        // Encoded payloads

        /\\x[0-9a-f]{2}/i,
        /\\u[0-9a-f]{4}/i,
        /%3c/i,
        /%3e/i,
        /%253c/i,
        /%253e/i,
        /&#x[0-9a-f]+;/i,
        /&#[0-9]+;/i,

        // Dangerous HTML elements
        /&lt;\s*iframe\b/i,
        /&lt;\s*svg\b/i,
        /&lt;\s*img\b/i,
        /&lt;\s*object\b/i,
        /&lt;\s*embed\b/i,
        /&lt;\s*link\b/i,
        /&lt;\s*meta\b/i,
        /&lt;\s*style\b/i,
        /&lt;\s*base\b/i,
        /&lt;\s*form\b/i
    ];

    const isMalicious = maliciousPatterns.some(pattern =>
        pattern.test(value)
    );

    if (isMalicious) {
        return {
            isValid: false,
            error: window.xssErrorMessage
        };
    }

    return {
        isValid: true
    };
}
window.validateInput = validateInput;